import { motion } from 'framer-motion'
import { Link, useLocation } from 'react-router-dom'

interface Props {
  onSobre?: () => void
  theme?: 'dark' | 'light'
  onToggleTheme?: () => void
}

const navLinks = [
  { label: 'Currículo', href: '/curriculo' },
  { label: 'Stats', href: '/stats' },
  { label: 'Blog', href: '/blog' },
]

function SunIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <circle cx="12" cy="12" r="5" />
      <line x1="12" y1="1" x2="12" y2="3" />
      <line x1="12" y1="21" x2="12" y2="23" />
      <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
      <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
      <line x1="1" y1="12" x2="3" y2="12" />
      <line x1="21" y1="12" x2="23" y2="12" />
      <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
    </svg>
  )
}

function MoonIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  )
}

export default function Header({ onSobre, theme, onToggleTheme }: Props) {
  const location = useLocation()

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.1 }}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 30,
        borderBottom: '1px solid var(--border)',
        background: 'var(--header-bg)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
      }}
    >
      <div style={{
        maxWidth: 1100,
        margin: '0 auto',
        padding: '0 1.5rem',
        height: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
      }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none', color: 'inherit' }}>
          <div style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            background: 'var(--bg3)',
            border: '1.5px solid var(--accent)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            flexShrink: 0,
          }}>
            <img src="/matheus.webp" alt="Matheus Edson" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
          </div>
          <span style={{ fontWeight: 600, fontSize: '0.95rem', letterSpacing: '-0.01em' }}>
            matheus edson
          </span>
        </Link>

        <nav style={{ display: 'flex', gap: '0.25rem', alignItems: 'center' }}>
          {onSobre && (
            <button
              onClick={onSobre}
              style={{
                padding: '0.35rem 0.75rem',
                borderRadius: 6,
                fontSize: '0.8rem',
                fontWeight: 500,
                color: 'var(--muted)',
                transition: 'color 0.15s, background 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--text)'; e.currentTarget.style.background = 'var(--border)' }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--muted)'; e.currentTarget.style.background = 'transparent' }}
            >
              Sobre
            </button>
          )}
          {navLinks.map(({ label, href }) => (
            <Link
              key={href}
              to={href}
              style={{
                padding: '0.35rem 0.75rem',
                borderRadius: 6,
                fontSize: '0.8rem',
                fontWeight: 500,
                color: location.pathname === href ? 'var(--text)' : 'var(--muted)',
                background: location.pathname === href ? 'var(--border)' : 'transparent',
                textDecoration: 'none',
                transition: 'color 0.15s, background 0.15s',
              }}
              onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.color = 'var(--text)'; (e.currentTarget as HTMLAnchorElement).style.background = 'var(--border)' }}
              onMouseLeave={e => {
                const isActive = location.pathname === href
                ;(e.currentTarget as HTMLAnchorElement).style.color = isActive ? 'var(--text)' : 'var(--muted)'
                ;(e.currentTarget as HTMLAnchorElement).style.background = isActive ? 'var(--border)' : 'transparent'
              }}
            >
              {label}
            </Link>
          ))}
          {onToggleTheme && (
            <button
              onClick={onToggleTheme}
              aria-label={theme === 'dark' ? 'Mudar para modo claro' : 'Mudar para modo escuro'}
              style={{
                padding: '0.35rem',
                borderRadius: 6,
                color: 'var(--muted)',
                display: 'flex',
                alignItems: 'center',
                transition: 'color 0.15s, background 0.15s',
                marginLeft: '0.25rem',
              }}
              onMouseEnter={e => { e.currentTarget.style.color = 'var(--text)'; e.currentTarget.style.background = 'var(--border)' }}
              onMouseLeave={e => { e.currentTarget.style.color = 'var(--muted)'; e.currentTarget.style.background = 'transparent' }}
            >
              {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
            </button>
          )}
        </nav>
      </div>
    </motion.header>
  )
}
